// const API_URL = import.meta.env.VITE_API_URL; // Vite
// mock
// const API_URL = "https://77c94eb2-363d-4c9b-b758-8a9b924ed9e8.mock.pstmn.io"; // Postman Mock Server
// const API_URL = "https://apitest.wificontrolbox.com/v1"; // Stage API
const API_URL = "https://api.wificontrolbox.com/v1"; // Production API


export default API_URL;